import styled from 'styled-components';
const CollapseItemStyle = styled.div `
	#collapse-description {
		overflow: hidden;
		/* height: 0; */

		display: grid;
		grid-template-rows: 0fr;
		transition: grid-template-rows 0.3s ease-out;

		#inner-wrapper-description {
			overflow: hidden;
		}
	}

	#collapse-item {
		&.active {
			#collapse-description {
				grid-template-rows: 1fr;
			}

			/* height: calc-size(auto, size); */
		}

		&.disable {
			pointer-events: none;

			#collapse-description {
				grid-template-rows: 0fr;
			}
		}
	}
`;
export default CollapseItemStyle;
//# sourceMappingURL=style.js.map